export default __webpack_public_path__ + "static/media/weelyLogoWhite.c05aaac4.svg";